import bg from "vuetify/lib/locale/bg.mjs";

export default Object.assign(
  {
    open: "Отвори",
    input: {
      clear: "Изчисти {0}",
    },
    datePicker: {
      itemsSelected: "{0} избрано",
    },
  },
  bg
);
